"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function default_1(tagString) {
    const emptyTagsRegex = new RegExp(/(((<\w+>)+[ \n(<br>)]*(<\/\w+>)+)+)|<br>/g);
    return tagString.replace(emptyTagsRegex, '');
}
exports.default = default_1;
